class ProductQuiz {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 3;
    this.answers = {};
    this.init();
  }

  init() {
    this.quiz = document.querySelector('[data-quiz]');
    if (!this.quiz) return;

    this.progressBar = this.quiz.querySelector('[data-progress]');
    this.bindEvents();
  }

  bindEvents() {
    // Option clicks
    this.quiz.querySelectorAll('.quiz-option').forEach(option => {
      option.addEventListener('click', (e) => this.handleOptionClick(e));
    });

    // Restart button
    const restartBtn = this.quiz.querySelector('.quiz-restart');
    if (restartBtn) {
      restartBtn.addEventListener('click', () => this.restart());
    }
  }

  handleOptionClick(e) {
    const option = e.currentTarget;
    const value = option.dataset.value;
    const step = this.currentStep;

    // Save answer
    this.answers[`step${step}`] = value;

    // Animate selection
    option.style.background = 'linear-gradient(135deg, #8a2be2 0%, #daa520 100%)';
    option.style.color = 'white';
    option.style.borderColor = '#8a2be2';

    // Move to next step
    setTimeout(() => {
      this.nextStep();
    }, 400);
  }

  nextStep() {
    // Hide current step
    const currentStepEl = this.quiz.querySelector(`[data-step="${this.currentStep}"]`);
    currentStepEl.classList.remove('active');

    this.currentStep++;

    if (this.currentStep > this.totalSteps) {
      // Show results
      this.showResults();
    } else {
      // Show next question
      const nextStepEl = this.quiz.querySelector(`[data-step="${this.currentStep}"]`);
      nextStepEl.classList.add('active');
      this.updateProgress();
    }
  }

  updateProgress() {
    const progress = (this.currentStep / this.totalSteps) * 100;
    this.progressBar.style.width = `${progress}%`;
  }

  async showResults() {
    this.progressBar.style.width = '100%';
    
    // Show results step
    const resultsStep = this.quiz.querySelector('[data-step="results"]');
    resultsStep.classList.add('active');

    // Fetch and display products
    await this.fetchRecommendedProducts();
  }

  async fetchRecommendedProducts() {
    const container = document.getElementById('quiz-recommendations');
    
    // Map answers to collection handles or tags
    const categoryMap = {
      'audio': 'audio-zvuk',
      'computers': 'kompyutri',
      'mobile': 'mobilni',
      'smart-home': 'smart-home',
      'accessories': 'aksesoari',
      'all': 'all'
    };

    const category = this.answers.step1;
    const collectionHandle = categoryMap[category] || 'all';

    try {
      // Fetch products from collection
      const response = await fetch(`/collections/${collectionHandle}/products.json?limit=3`);
      const data = await response.json();
      
      if (data.products && data.products.length > 0) {
        this.displayProducts(data.products);
      } else {
        container.innerHTML = '<p style="text-align: center;">Скоро ще добавим продукти в тази категория!</p>';
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      container.innerHTML = '<p style="text-align: center;">Моля, опитайте отново.</p>';
    }
  }

  displayProducts(products) {
    const container = document.getElementById('quiz-recommendations');
    
    const html = products.map(product => {
      const price = (product.variants[0].price / 100).toFixed(2);
      const image = product.images[0] ? product.images[0].src : '';
      
      return `
        <div class="product-card">
          ${image ? `<img src="${image}" alt="${product.title}" class="product-image">` : ''}
          <div class="product-info">
            <h3 class="product-title">${product.title}</h3>
            <div class="product-price">${price}€</div>
            <a href="/products/${product.handle}" class="product-link">Виж продукта</a>
          </div>
        </div>
      `;
    }).join('');

    container.innerHTML = html;
  }

  restart() {
    this.currentStep = 1;
    this.answers = {};
    
    // Reset all steps
    this.quiz.querySelectorAll('.quiz-step').forEach(step => {
      step.classList.remove('active');
    });
    
    // Reset option styles
    this.quiz.querySelectorAll('.quiz-option').forEach(option => {
      option.style.background = '';
      option.style.color = '';
      option.style.borderColor = '';
    });
    
    // Show first step
    this.quiz.querySelector('[data-step="1"]').classList.add('active');
    this.updateProgress();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductQuiz());
} else {
  new ProductQuiz();
}
